import React from 'react';
import { Animated, View } from 'react-native';

export default class FadeIn extends React.Component {

  constructor(props) {
    super(props);

    // props include:
    //   - delay - can be set to 0 for no delay at all
    //   - lastActionTime - so we can track how long it has been since last fade in
    //   - itemKey - so we can track which have faded in yet or not
    //   - fadeOutAfter - causes fade out after x milliseconds

    this.state = {
      opacityAnimate: new Animated.Value(0),
      heightAnimate: new Animated.Value(1)
    }

    this.startedAnimatingIn = false;
    this.finishedAnimatingIn = false;

    this.startedAnimatingOut = false;
    this.finishedAnimatingOut = false;

  }

  animateInAfterDelay = () => {
    this.startedAnimatingIn = true;

    let delay = 1;

    if (this.props.delay !== null) {
      delay = this.props.delay;
    }

    setTimeout(this.animateIn, delay * 1000);
  }

  animateIn = () => {
    let {opacityAnimate} = this.state;
    opacityAnimate.setValue(0);
    Animated.timing(opacityAnimate, {toValue: 1, duration: 1000, useNativeDriver: false}).start();

    if (this.props.growHeight === true) {
      let {heightAnimate} = this.state;
      heightAnimate.setValue(0);
      const targetHeight = this.props.growHeightTo || 175;
      Animated.timing(heightAnimate, {toValue: targetHeight, duration: 750, useNativeDriver: false}).start();
    }

    this.finishedAnimatingIn = true;

    if (!!(this.props.fadeOutAfter)) {
      let timeUntilFadeout = (this.props.fadeOutAfter - 2) * 1000;
      setTimeout(this.animateOut, timeUntilFadeout);
    }
  }

  animateOut = () => {
    if (!!(this.props.fadeOutAfter)) {
      let {opacityAnimate} = this.state;
      opacityAnimate.setValue(1);
      Animated.timing(opacityAnimate, {toValue: 0, duration: 1000, useNativeDriver: false}).start();
    }
  }

  componentDidMount() {
    let {opacityAnimate} = this.state;
    opacityAnimate.setValue(0.0);
    if (this.props.growHeight === true) {
      let {heightAnimate} = this.state;
      heightAnimate.setValue(0);
    }

    this.animateInAfterDelay();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.itemKey !== this.props.itemKey) {
      this.startedAnimatingIn = false;
      this.finishedAnimatingIn = false;

      if (this.props.growHeight === true) {
        this.setState({opacityAnimate: new Animated.Value(0),
        heightAnimate: new Animated.Value(1)});
      } else {
        this.setState({opacityAnimate: new Animated.Value(0)});
      }

      this.animateInAfterDelay();
    }
  }

  render() {
    if (true === this.props.skip) {
      return (
        <View>
          {this.props.children}
        </View>
      )
    } else {

      let myStyle = {opacity: this.state.opacityAnimate};
      if (this.props.growHeight === true) {
        myStyle["height"] = this.state.heightAnimate;
      }
      // NOTE: layout can get weird if you don't specify flex:1 here
      if (this.props.flex) {
        myStyle["flex"] = this.props.flex;
      }

      return (
        <Animated.View style={myStyle}>
          {this.props.children}
        </Animated.View>
      )
    }
  }
}
